import lz from 'lz-string';
const { compressToEncodedURIComponent, decompressFromEncodedURIComponent } = lz;

export const LEFT = '<!--';
export const RIGHT = '-->';
export const DATA_KEY = 'hypernova-key';
export const DATA_ID = 'hypernova-id';

const ENCODE = [
  ['&', '&amp;'],
  ['>', '&gt;'],
];

export const encode = (obj: Record<string, unknown>, { compress }: { compress: boolean } = { compress: true }) => {
  const encoded = JSON.stringify(obj).replace(/-->/g, '--&gt;');
  return compress ? compressToEncodedURIComponent(encoded) : encoded;
};

export const load = (name: string, isHonoRendered: boolean) => {
  const key = name.replace(/\W/g, '');
  const nodes = document.querySelectorAll(`div[data-${DATA_KEY}="${key}"]`);

  return Array.prototype.map.call(nodes, (node: HTMLDivElement) => {
    const id: string = node.getAttribute(`data-${DATA_ID}`)!;
    const data = fromScript(
      {
        [DATA_KEY]: key,
        [DATA_ID]: id,
      },
      isHonoRendered
    )!;
    return { node, data };
  }) as Array<{
    node: HTMLDivElement;
    data: Record<string, unknown>;
  }>;
};

const decode = <T extends Record<string, unknown>>(res: string, isHonoRendered: boolean) => {
  const decompressedResponse = isHonoRendered ? decompressFromEncodedURIComponent(res) : res;
  const jsonPayload = ENCODE.reduceRight((str, coding) => {
    const [encodeChar, htmlEntity] = coding;
    return str.replace(new RegExp(htmlEntity!, 'g'), encodeChar!);
  }, decompressedResponse || res);

  try {
    return JSON.parse(jsonPayload) as T;
  } catch (error) {
    console.error('[hydrate.util] JSON parse error', error);
    return {} as T;
  }
};

const makeValidDataAttribute = (attr: string, value: string) => {
  const encodedAttr = attr.toLowerCase().replace(/[^0-9a-z_-]/g, '');
  const encodedValue = value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

  return `data-${encodedAttr}="${encodedValue}"`;
};

const fromScript = <T extends Record<string, string>>(attrs: T, isHonoRendered: boolean) => {
  const selectors = Object.keys(attrs)
    .map(name => `[${makeValidDataAttribute(name, attrs[name]!)}]`)
    .join('');

  const node = document.querySelector(`script${selectors}`);

  if (!node) {
    return null;
  }

  const jsonPayload = node.innerHTML;

  return decode(jsonPayload.slice(LEFT.length, jsonPayload.length - RIGHT.length), isHonoRendered);
};
